module.exports = __webpack_public_path__ + "static/media/responsive.8141e85f.png";